/**统计 */
// export default [
//     {
//         name:'statistics',
//         path:'statistics',
//         meta: { title: '统计' },
//         component: ()=>import('@/pages/statistics/index.vue')
//     }
// ]

/** 数据统计 */
export default{
    name: 'statistics',
    path: 'statistics',
    meta: { title: '数据统计' },
    component: ()=>import('@/pages/index.vue'),
    children: [
        {
            name: 'statistics-index',
            path: 'index',
            meta: { title: '队伍数据' },
            component: ()=>import('@/pages/statistics/index.vue')
        },
        {
            name: 'statistics-system',
            path: 'system',
            meta: { title: '订单数据' },
            component: ()=>import('@/pages/statistics/system.vue')
        }

    ]
}
